import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Objects } from '../../../util/objects';

@Component({
  selector: 'ngx-request-flow-column',
  template: `
  <div class="flow-box" [style.color]="params.data.flowCodeColor.color" [class.pointer]="useButton" (click)="onClick()">
    <div class="flow-box-left"></div>
    <div [style.border-color]="params.data.flowCodeColor.background" [ngClass]="{
      'flow-box-center-line': 'flow-end' == params.data.flowCode || 'flow-ing' == params.data.flowCode,
      'flow-box-center': 'flow-end' != params.data.flowCode && 'flow-end' != params.data.flowCode
      }"></div>
    <div class="flow-box-right"></div>
    <div [style.border-color]="params.data.flowCodeColor.background"
      [style.background-color]="params.data.flowCodeColor.background"
      [ngClass]="{
        'flow-box-contents-start': 'flow-start' == params.data.flowCode,
        'flow-box-contents-end': 'flow-end' == params.data.flowCode,
        'flow-box-contents': 'flow-start' != params.data.flowCode && 'flow-end' != params.data.flowCode
        }">{{params.data.requestOrder}}</div>
    <div class="flow-box-left"></div>
    <div [ngClass]="{
      'flow-box-center-line': 'flow-start' == params.data.flowCode || 'flow-ing' == params.data.flowCode,
      'flow-box-center': 'flow-ing' != params.data.flowCode && 'flow-start' != params.data.flowCode}"
      [style.border-color]="params.data.flowCodeColor.background"></div>
    <div class="flow-box-right"></div>
  </div>`,
  encapsulation: ViewEncapsulation.None,
})
export class FlowColumnComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public useButton: boolean = false;

  constructor(private router: Router) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    if (this.params.hasOwnProperty('useButton'))
      this.useButton = Objects.safeGetValue(this.params, 'useButton', false);
  }

  ngOnInit() {}

  onClick() {
    if (!this.useButton) return;

    this.params.context.clickFlow(this.params.data);
  }

}
